import React from 'react';
import { Info, AlertTriangle, CheckCircle2, Lightbulb } from 'lucide-react';

const VARIANTS = {
  info:    { bg: 'bg-blue-50',   border: 'border-blue-200',   icon: Info,          iconColor: 'text-blue-500',   titleColor: 'text-blue-800'  },
  warning: { bg: 'bg-amber-50',  border: 'border-amber-200',  icon: AlertTriangle, iconColor: 'text-amber-500',  titleColor: 'text-amber-800' },
  success: { bg: 'bg-green-50',  border: 'border-green-200',  icon: CheckCircle2,  iconColor: 'text-green-500',  titleColor: 'text-green-800' },
  tip:     { bg: 'bg-orange-50', border: 'border-orange-200', icon: Lightbulb,     iconColor: 'text-orange-500', titleColor: 'text-orange-800'},
};

export function HelpCallout({ type = 'info', title, children }) {
  const v = VARIANTS[type] || VARIANTS.info;
  const Icon = v.icon;
  return (
    <div className={`flex gap-3 p-4 rounded-xl border ${v.bg} ${v.border} my-4`}>
      <Icon size={18} className={`flex-shrink-0 mt-0.5 ${v.iconColor}`} />
      <div className="text-sm">
        {title && <p className={`font-semibold mb-1 ${v.titleColor}`}>{title}</p>}
        <div className="text-slate-700 leading-relaxed">{children}</div>
      </div>
    </div>
  );
}
